import {ActionService, ApiCallService} from "@libs/ClientService"
import {ILabelSet} from "@backend/types"


export const labelSetActions = new ActionService<ILabelSet>("labelSet")

export const labelSetApiCalls = new ApiCallService<ILabelSet>("labelSet")


// import axios from "axios"
//
// import {ActionService, ApiCallService, apiRequest, ListQueryType} from "@libs/ClientService"
// import {ILabel} from "@backend/types"
//
// class LabelActionService extends ActionService<ILabel> {
//
//     constructor() {
//         super("label")
//
//         this.actionTypes.PARENTS = `${this.name.toUpperCase()}_GET`
//     }
//
//     getParents = (query: ListQueryType) => dispatch => apiRequest<ILabel[]>(axios.get(`${this.resourceUrl}/parents`, {params: query}), {
//         type: labelActions.actionTypes.PARENTS,
//         dispatch
//     })
// }
//
// export const labelActions = new LabelActionService()
//
// class LabelApiService extends ApiCallService<ILabel> {
//     constructor() {
//         super("label")
//     }
//
//     getParents = (query: ListQueryType) => apiRequest<ILabel[]>(axios.get(`${this.resourceUrl}/parents`, {
//         params: query
//     }))
// }
//
// export const labelApiCalls = new LabelApiService()